module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_1 public_noxy"
  }, [_c('div', {
    staticClass: "login_2 "
  }), _vm._v(" "), _c('div', {
    staticClass: " public_y login_tup "
  }, [_c('div', {
    staticClass: "dispaly_flex11 login_sz display_row_jc_ac",
    staticStyle: {
      "height": "180px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.url.url_1
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "height": "calc(100% - 180px)",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "max-height": "600px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginPage[0].flag),
      expression: "loginPage[0].flag"
    }],
    staticClass: "public_pop_hz login_hz dispaly_flex00"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "login_name",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "login_pwd",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "login_btn",
    attrs: {
      "type": "button",
      "value": "登  录"
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login_tip display_row_js_ac"
  }, [_c('div', {
    staticClass: "forget_password display_row_ac"
  }, [_c('div', {
    staticClass: "login_tip_badge display_row_jc_ac"
  }, [_vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "tip_forget"
  }, [_vm._v("忘记密码?")]), _vm._v(" "), _c('div', {
    staticClass: "ogin_tip_badgema display_row_jc_ac",
    on: {
      "click": function($event) {
        return _vm.mima()
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flog),
      expression: "flog"
    }],
    attrs: {
      "src": require("./images/gx.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ogin_tip_badgemas",
    on: {
      "click": function($event) {
        return _vm.mima()
      }
    }
  }, [_vm._v(" 记住密码")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "login_tip_regist"
  }, [_vm._v("还没有帐号? ")]), _c('span', {
    staticClass: "regist_click",
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("点击注册")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginPage[1].flag),
      expression: "loginPage[1].flag"
    }],
    staticClass: "dispaly_flex00",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('registeredss')], 1), _vm._v(" "), (_vm.loginPage[2].flag) ? _c('div', {
    staticClass: "dispaly_flex00",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('companyregistered')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dispaly_flex00 login_wz display_column_ac"
  }, [_c('p', [_vm._v(_vm._s(_vm.names.names_1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.names.names_2))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_welcome display_row_jc_ac"
  }, [_c('div', {
    staticClass: "login_welcome_title"
  }, [_vm._v("账号登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4c4c9c05"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 1071
// module chunks = 1